import React from 'react';
import qs from 'qs';
import { locationT } from '@ordermentum/ui-types';
import axios from 'axios';
import Spinner from '@ordermentum/ui-shared/foundations/Spinner';
import { safeRedirect } from '@ordermentum/ui-shared/helpers/urls';
import { LoginBase } from './LoginBase';
import { Header } from './DefaultLogin';
import history from '../../lib/history';
import { MFAAction } from './Forms/MFAForm';

export const SocialUpgrade = (props: { location: locationT }) => {
  const onLoad = async () => {
    const queryStrings = qs.parse(props.location.search, {
      ignoreQueryPrefix: true,
    });
    const destination = (queryStrings.returnUrl || '/') as string;
    try {
      await axios.post(`/v1/auth/social/upgrade`, {
        provider: queryStrings.provider,
        code: queryStrings.code,
      });
      window.location.href = safeRedirect(destination);
    } catch (e) {
      if (
        e?.isAxiosError &&
        e.response.status === 403 &&
        e.response.data.error === 'mfa_required'
      ) {
        const { method, state, target, userId } = e.response.data.data;
        history.push(
          `/mfa?method=${method}&state=${state}&target=${target}&userId=${userId}&action=${MFAAction.LOGIN}&destination=${destination}`
        );
      } else {
        window.location.href = safeRedirect('/');
      }
    }
  };

  onLoad();

  return (
    <LoginBase type="default" header={<Header />}>
      <Spinner size="XL" />
    </LoginBase>
  );
};
